<template>
  <div>
    <div v-for="chart in charts" :key="key(chart)" class="c-div" :class="`c-${category}`">
      <highcharts v-if="chart" :options="buildChart(chart)" />
      <br />
    </div>
  </div>
</template>

<script>
import { Chart as highcharts } from 'highcharts-vue'

export default {
  components: {
    highcharts,
  },
  props: {
    charts: Array,
    category: String,
  },
  methods: {
    key(chart) {
      return chart?.title ?? `chart-${Math.random() * Math.random()}`
    },
    buildChart(chart) {
      const data = (function() {
        const data = []

        if (!chart.categories) {
          for (let l = 0; l < chart.data.length; l++) {
            switch(chart.type) {
            case 'spline':
              if (data.length === 0) {
                data.push({ name: chart.axis?.y ?? 'Dados', data: [] })
              }

              data[0]['data'].push(chart.data[l])
              break
            default:
              data.push({ name: chart.labels[l], data: [chart.data[l]] })
              break
            }
          }

          return data
        }

        chart.categories.forEach((category, index) => data.push({ name: category, data: chart.data[index] }))

        return data

      })()

      const options = {
        chart: {
          type: chart.type,
        },
        title: {
          text: chart.title,
        },
        tooltip: {
          headerFormat: '<table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}:&nbsp;</td><td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true,
        },
        series: data,
      }

      if (chart.axis) {
        options['xAxis'] = {
          crosshair: true,
          title: {
            text: chart.axis.x,
          },
        }

        options['yAxis'] = {
          min: 0,
          title: {
            text: chart.axis.y,
          },
        }

        if (chart.type === 'spline') {
          options['xAxis']['categories'] = chart.labels
        }
      }

      if (chart.type === 'column') {
        options['plotOptions'] = {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        }
      }

      return options
    },
  },
}
</script>
